export default "__VITE_ASSET___wlIPdoj__"